import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable()
export class IndustriesService {

    constructor(private http: HttpClient) { }

    public fetchIndustries(params: object): Observable<any> {
        const url = `${environment.API_ENDPOINT}/admin/industry/list`;
        return this.http.post(url, params);
    }
    public fetchIndustry(id: number): Observable<any> {
        const url = `${environment.API_ENDPOINT}/admin/industry/${id}`;
        return this.http.get(url, {});
    }

    public deleteIndustry(id: number): Observable<any> {
        const url = `${environment.API_ENDPOINT}/admin/industry/${id}`;
        return this.http.delete(url);
    }

    public createIndustry(params: object): Observable<any> {
        const url = `${environment.API_ENDPOINT}/admin/industry`;
        return this.http.put(url, params);
    }

    public updateIndustry(id: number, params: object): Observable<any> {
        const url = `${environment.API_ENDPOINT}/admin/industry/${id}`;
        return this.http.post(url, params);
    }

}